/*
  CGB – Find Your Coogee quiz: shared helpers + header button + returning-visitor popup (loaded on every page)
  Used by: snippets/cgb-quiz-header-button.liquid, sections/cgb-quiz-page.liquid, sections/cgb-quiz-results.liquid
  Scoring logic is copied unchanged from sections/find-your-coogee-quiz.liquid (getResult) – only rankBikes() is new.
*/
(function () {
  if (window.CgbQuiz) return;

  var STORAGE_KEY = 'cgb-quiz:result';
  var PENDING_KEY = 'cgb-quiz:pending';
  var PENDING_MAX_AGE = 30 * 60 * 1000;

  /* ---------- Scoring (unchanged from find-your-coogee-quiz.liquid) ---------- */
  var BIKES = ['EXPLORER', 'DRIFTER', 'CRUISER', 'MINI', 'BLADE', 'HALO', 'NOVA'];
  var OFFROAD = ['EXPLORER', 'DRIFTER', 'CRUISER', 'BLADE'];
  var BIKE_SLUGS = {
    EXPLORER: 'explorer', DRIFTER: 'drifter', CRUISER: 'cruiser-dual-battery', MINI: 'cruiser-mini',
    BLADE: 'blade', HALO: 'halo', NOVA: 'nova'
  };
  var MATRIX = {
    q1: { A: [0,0,0,1,0,3,3], B: [0,3,2,0,0,2,0], C: [1,1,1,0,3,0,0], D: [2,2,3,0,0,3,2] },
    q2: { A: [0,0,-1,1,0,1,1], B: [0,3,0,0,2,0,2], C: [2,0,2,0,2,0,0], D: [0,0,3,0,0,0,0] },
    q3: { A: [0,0,0,0,0,3,3], B: [0,0,0,3,0,1,1], C: [3,3,3,0,0,0,0], D: [1,1,0,0,3,0,0] },
    q4: { A: [2,2,0,0,0,0,0], B: [0,0,0,1,2,0,1], C: [0,2,0,0,0,0,2], D: [0,0,0,2,0,0,1], E: [0,0,0,0,0,0,0] },
    q5: { A: [0,0,0,0,0,0,0], B: [3,0,0,0,0,0,0], C: [2,0,2,0,0,0,3], D: [0,0,0,3,0,1,0], E: [0,0,0,0,0,0,0] }
  };

  function matrixVal(q, answer, bike) {
    var row = MATRIX[q] && MATRIX[q][answer];
    return row ? row[BIKES.indexOf(bike)] : 0;
  }

  function getResult(answers) {
    var q1 = answers.q1, q3 = answers.q3, q5 = answers.q5;
    var eligible, skipQ3Q4 = false, showMessage1 = false, showMessage2 = false;

    if (q5 === 'D') {
      eligible = (q1 === 'C') ? OFFROAD.slice() : ['MINI', 'HALO'];
      skipQ3Q4 = true;
      showMessage2 = true;
    } else {
      eligible = BIKES.slice();
      if (q3 === 'A') { eligible = eligible.filter(function (b) { return b === 'HALO' || b === 'NOVA'; }); }
      if (q5 === 'B') { eligible = eligible.filter(function (b) { return b !== 'HALO'; }); }
      if (q1 === 'C') {
        var intersected = eligible.filter(function (b) { return OFFROAD.indexOf(b) > -1; });
        if (intersected.length > 0) { eligible = intersected; } else { showMessage1 = true; }
      }
    }

    function scoreBike(b, skip34) {
      var s = matrixVal('q1', q1, b) + matrixVal('q2', answers.q2, b) + matrixVal('q5', q5, b);
      if (!skip34) { s += matrixVal('q3', q3, b) + matrixVal('q4', answers.q4, b); }
      return s;
    }

    function pickWinner(pool, skip34, skipQ4InCascade) {
      var scores = {};
      pool.forEach(function (b) { scores[b] = scoreBike(b, skip34); });
      var maxScore = Math.max.apply(null, pool.map(function (b) { return scores[b]; }));
      var tied = pool.filter(function (b) { return scores[b] === maxScore; });
      if (tied.length === 1) return tied[0];

      var cascade = [];
      if (!skip34) cascade.push('q3');
      cascade.push('q5', 'q2', 'q1');
      if (!skipQ4InCascade && !skip34) cascade.push('q4');

      for (var i = 0; i < cascade.length; i++) {
        var q = cascade[i];
        var vals = tied.map(function (b) { return matrixVal(q, answers[q], b); });
        var maxV = Math.max.apply(null, vals);
        var newTied = tied.filter(function (b, idx) { return vals[idx] === maxV; });
        if (newTied.length === 1) return newTied[0];
        tied = newTied;
      }
      for (var j = 0; j < BIKES.length; j++) { if (tied.indexOf(BIKES[j]) > -1) return BIKES[j]; }
      return tied[0];
    }

    var winner = pickWinner(eligible, skipQ3Q4, skipQ3Q4);

    if (!skipQ3Q4) {
      var scoreNoQ4 = function (b) { return matrixVal('q1', q1, b) + matrixVal('q2', answers.q2, b) + matrixVal('q3', q3, b) + matrixVal('q5', q5, b); };
      var scoresNoQ4 = {};
      eligible.forEach(function (b) { scoresNoQ4[b] = scoreNoQ4(b); });
      var maxNoQ4 = Math.max.apply(null, eligible.map(function (b) { return scoresNoQ4[b]; }));
      var tiedNoQ4 = eligible.filter(function (b) { return scoresNoQ4[b] === maxNoQ4; });
      if (tiedNoQ4.length > 1) {
        var cascade2 = ['q3', 'q5', 'q2', 'q1'];
        for (var k = 0; k < cascade2.length; k++) {
          var q2k = cascade2[k];
          var vals2 = tiedNoQ4.map(function (b) { return matrixVal(q2k, answers[q2k], b); });
          var maxV2 = Math.max.apply(null, vals2);
          var nt = tiedNoQ4.filter(function (b, idx) { return vals2[idx] === maxV2; });
          if (nt.length === 1) { tiedNoQ4 = nt; break; }
          tiedNoQ4 = nt;
        }
        if (tiedNoQ4.length > 1) {
          for (var m = 0; m < BIKES.length; m++) { if (tiedNoQ4.indexOf(BIKES[m]) > -1) { tiedNoQ4 = [BIKES[m]]; break; } }
        }
      }
      var w2 = tiedNoQ4[0];
      if (w2 !== winner && matrixVal('q3', q3, w2) > matrixVal('q3', q3, winner)) {
        winner = w2;
      }
    }

    return { bike: winner, showMessage1: showMessage1, showMessage2: showMessage2, eligible: eligible, skipQ3Q4: skipQ3Q4, scoreBike: scoreBike };
  }

  /* New: order bikes by the same score + tie-break cascade, to find the second-best bike. */
  function rankBikes(pool, answers, result) {
    var skip = result.skipQ3Q4;
    var cascade = skip ? ['q5', 'q2', 'q1'] : ['q3', 'q5', 'q2', 'q1', 'q4'];
    return pool.slice().sort(function (a, b) {
      var d = result.scoreBike(b, skip) - result.scoreBike(a, skip);
      if (d) return d;
      for (var i = 0; i < cascade.length; i++) {
        var q = cascade[i];
        var dv = matrixVal(q, answers[q], b) - matrixVal(q, answers[q], a);
        if (dv) return dv;
      }
      return BIKES.indexOf(a) - BIKES.indexOf(b);
    });
  }

  /*
    ranking = the match, then the rest of the eligible bikes, then all other bikes (each group by score).
    ranking[1] is the same alternative as before; the rest is the fallback order when a bike
    isn't available in the visitor's market.
  */
  function computeMatch(answers) {
    var result = getResult(answers);
    var others = function (b) { return b !== result.bike; };
    var rest = rankBikes(result.eligible.filter(others), answers, result);
    var outside = rankBikes(BIKES.filter(function (b) { return result.eligible.indexOf(b) === -1; }), answers, result);
    var ranking = [result.bike].concat(rest, outside);
    var note = '';
    if (result.showMessage1) note = 'conflict';
    else if (result.showMessage2) note = 'someone';
    return { bike: ranking[0], alt: ranking[1], note: note, ranking: ranking };
  }

  /*
    Pick the bikes to show from the ranking.
    - availableKeys: bikes whose product exists in this market (others are skipped)
    - inStockKeys: bikes that can be bought right now. The match is the first in-stock bike; the alternative
      is the next in-stock bike. A sold-out bike is only used when nothing (else) is in stock.
    Returns { bike, alt, ranking } (ranking reordered: match, alternative, rest) or null.
  */
  function pickAvailable(ranking, availableKeys, inStockKeys) {
    var list = (ranking || []).filter(function (b, i, arr) { return BIKES.indexOf(b) > -1 && arr.indexOf(b) === i; });
    BIKES.forEach(function (b) { if (list.indexOf(b) === -1) list.push(b); });
    if (availableKeys) list = list.filter(function (b) { return availableKeys.indexOf(b) > -1; });
    if (!list.length) return null;
    var inStock = inStockKeys ? list.filter(function (b) { return inStockKeys.indexOf(b) > -1; }) : list;
    var bike = inStock[0] || list[0];
    var others = function (b) { return b !== bike; };
    var alt = inStock.filter(others)[0] || list.filter(others)[0] || null;
    var rest = list.filter(function (b) { return b !== bike && b !== alt; });
    return { bike: bike, alt: alt, ranking: [bike].concat(alt ? [alt] : [], rest) };
  }

  /* ---------- Storage ---------- */
  function readJSON(key) {
    try { var v = window.localStorage.getItem(key); return v ? JSON.parse(v) : null; } catch (e) { return null; }
  }
  function writeJSON(key, value) {
    try {
      if (value === null) window.localStorage.removeItem(key);
      else window.localStorage.setItem(key, JSON.stringify(value));
    } catch (e) { /* storage blocked – quiz still works via URL params */ }
  }

  function getSaved() {
    var saved = readJSON(STORAGE_KEY);
    return saved && saved.bike && BIKES.indexOf(saved.bike) > -1 ? saved : null;
  }
  function save(patch) {
    var next = Object.assign({}, getSaved() || {}, patch, { ts: Date.now() });
    writeJSON(STORAGE_KEY, next);
    document.dispatchEvent(new CustomEvent('cgb-quiz:updated', { detail: next }));
    return next;
  }

  function resultsHref(saved, baseUrl) {
    var base = (saved && saved.resultsUrl) || baseUrl;
    if (!base || !saved) return base || '';
    var url = new URL(base, window.location.origin);
    url.searchParams.set('bike', saved.bike);
    if (saved.alt) url.searchParams.set('alt', saved.alt);
    if (saved.note) url.searchParams.set('note', saved.note);
    return url.pathname + url.search;
  }

  /* ---------- Lead capture (Shopify customer form) ---------- */
  function setLeadTags(form, bike) {
    var tagInput = form.querySelector('[name="contact[tags]"]');
    if (!tagInput) return;
    var base = tagInput.getAttribute('data-base-tags') || 'quiz-lead';
    tagInput.value = bike && BIKE_SLUGS[bike] ? base + ', quiz-bike-' + BIKE_SLUGS[bike] : base;
  }

  /* Resolves 'ok' | 'challenge' | 'error'. A 'challenge' means Shopify wants a captcha: the caller falls back to a normal submit. */
  function submitLead(form) {
    return fetch(form.action, {
      method: 'POST',
      body: new FormData(form),
      credentials: 'same-origin',
      headers: { Accept: 'text/html' }
    })
      .then(function (res) {
        if (/\/challenge/.test(res.url)) return 'challenge';
        // Shopify redirects to ?customer_posted=true on success; a normal page response is also treated as sent.
        return res.ok ? 'ok' : 'error';
      })
      .catch(function () { return 'error'; });
  }

  function nativeSubmit(form, returnTo) {
    writeJSON(PENDING_KEY, { returnTo: returnTo || '', ts: Date.now() });
    HTMLFormElement.prototype.submit.call(form);
  }

  /*
    Omnisend (app embed) – identify the contact and send a "Quiz signup" event that Coogee's team uses
    to trigger the welcome email with a unique code. Consent itself comes from the Shopify customer form
    (synced to Omnisend as subscribed). Called only after a successful signup. Skipped if Omnisend isn't loaded.
  */
  function sendToOmnisend(email, bike, source) {
    var omnisend = window.omnisend;
    if (!omnisend || typeof omnisend.identifyContact !== 'function' || typeof omnisend.push !== 'function') return false;
    try {
      omnisend.identifyContact({ email: String(email || '').trim() });
      omnisend.push(['track', 'Quiz signup', {
        bike: bike || '',
        bike_handle: bike && BIKE_SLUGS[bike] ? BIKE_SLUGS[bike] : '',
        source: source || 'quiz'
      }]);
      return true;
    } catch (e) {
      return false;
    }
  }

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || '').trim());
  }

  /* After a native (captcha) submit, Shopify comes back with ?customer_posted=true */
  /*
    After a native (captcha) submit Shopify comes back with ?customer_posted=true, or straight from the /challenge page.
    Either way the signup went through: mark it, then return to the quiz URL it was sent from (incl. ?view=…).
  */
  function handlePendingSubmit() {
    var pending = readJSON(PENDING_KEY);
    if (!pending) return;
    if (Date.now() - (pending.ts || 0) > PENDING_MAX_AGE) { writeJSON(PENDING_KEY, null); return; }
    var params = new URLSearchParams(window.location.search);
    var posted = params.get('customer_posted') === 'true' || /\/challenge/.test(document.referrer || '');
    if (!posted) return;
    writeJSON(PENDING_KEY, null);
    if (getSaved()) save({ email: 'submitted' });
    if (pending.returnTo) {
      var target = new URL(pending.returnTo, window.location.origin);
      var here = new URL(window.location.href);
      here.searchParams.delete('customer_posted');
      if (target.pathname !== here.pathname || target.search !== here.search) window.location.replace(target.pathname + target.search);
    }
  }

  /* ---------- Header button + returning-visitor popup ---------- */
  var DEFAULT_QUIZ_URL = '/pages/find-your-coogee';

  function getConfig() {
    var el = document.querySelector('[data-cgb-quiz-config]');
    if (!el) return {};
    try { return JSON.parse(el.textContent) || {}; } catch (e) { return {}; }
  }

  /* While testing on an unpublished theme the quiz page needs ?view=cgb-quiz; on the live theme links stay clean. */
  function isUnpublishedTheme() {
    var s = window.MinimogSettings;
    return !!(s && s.theme && s.theme.role && s.theme.role !== 'main');
  }

  function quizUrl() {
    var config = getConfig();
    var trigger = document.querySelector('[data-cgb-quiz-trigger]');
    var url = config.quizUrl || (trigger && trigger.getAttribute('href')) || DEFAULT_QUIZ_URL;
    if (!isUnpublishedTheme()) return url;
    var u = new URL(url, window.location.origin);
    if (!u.searchParams.get('view')) u.searchParams.set('view', 'cgb-quiz');
    return u.pathname + u.search;
  }

  function quizPage() {
    return document.querySelector('cgb-quiz-page');
  }

  function updateTriggers() {
    var config = getConfig();
    var saved = getSaved();
    var url = quizUrl();
    document.querySelectorAll('[data-cgb-quiz-trigger]').forEach(function (trigger) {
      var label = trigger.querySelector('[data-cgb-quiz-label]');
      var text = saved ? (config.labelDone || trigger.dataset.labelDone) : (config.labelDefault || trigger.dataset.labelDefault);
      if (label && text) label.textContent = text;
      if (text) trigger.setAttribute('aria-label', text);
      trigger.setAttribute('href', url);
      trigger.classList.toggle('cgb-quiz-trigger--done', !!saved);
    });
  }

  /* Ask the quiz page (if this is it) to restart or show results; otherwise navigate there. */
  function goToQuiz(mode) {
    var page = quizPage();
    if (page) {
      document.dispatchEvent(new CustomEvent(mode === 'results' ? 'cgb-quiz:show-results' : 'cgb-quiz:restart'));
      return;
    }
    window.location.href = quizUrl() + (mode === 'retake' ? '#retake' : '');
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-cgb-quiz-trigger]');
    if (trigger) {
      var popup = document.querySelector('cgb-quiz-popup');
      if (getSaved() && popup && typeof popup.open === 'function') {
        event.preventDefault();
        popup.open(trigger);
      } else if (quizPage()) {
        event.preventDefault();
        goToQuiz('retake');
      }
      return; // otherwise: normal link to the quiz page
    }
    var action = event.target.closest('[data-cgb-quiz-retake], [data-cgb-quiz-results]');
    if (!action) return;
    event.preventDefault();
    var popupEl = action.closest('cgb-quiz-popup');
    if (popupEl) popupEl.close(false);
    goToQuiz(action.hasAttribute('data-cgb-quiz-retake') ? 'retake' : 'results');
  });

  document.addEventListener('cgb-quiz:updated', updateTriggers);

  function onReady(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }
  onReady(function () {
    handlePendingSubmit();
    updateTriggers();
  });

  window.CgbQuiz = {
    BIKES: BIKES,
    computeMatch: computeMatch,
    pickAvailable: pickAvailable,
    getSaved: getSaved,
    save: save,
    resultsHref: resultsHref,
    setLeadTags: setLeadTags,
    submitLead: submitLead,
    nativeSubmit: nativeSubmit,
    sendToOmnisend: sendToOmnisend,
    isValidEmail: isValidEmail,
    updateTriggers: updateTriggers,
    getConfig: getConfig,
    quizUrl: quizUrl
  };
})();

/* ---------- <cgb-quiz-popup> "You've already found your Coogee" (rendered by the header button snippet) ---------- */
if (!customElements.get('cgb-quiz-popup')) {
  class CgbQuizPopup extends HTMLElement {
    connectedCallback() {
      // Rendered inside the desktop header (hidden on phones, sticky/transformed): move to <body> so it shows everywhere.
      if (this.parentElement !== document.body) {
        document.body.appendChild(this);
        return; // connectedCallback runs again after the move
      }
      if (this.ready) return;
      this.ready = true;
      this.modal = this.querySelector('[data-cgb-popup]');
      this.panel = this.querySelector('[data-cgb-popup-panel]');
      this.onKeydown = (e) => { if (e.key === 'Escape') this.close(); };
      this.addEventListener('click', (e) => {
        if (e.target.closest('[data-cgb-popup-close]')) { e.preventDefault(); this.close(); }
      });
      this.applyConfig();
    }

    /* Text from the optional "CGB – Quiz header settings" section overrides the snippet defaults */
    applyConfig() {
      var popup = (window.CgbQuiz.getConfig() || {}).popup || {};
      var set = (sel, text) => { var el = this.querySelector(sel); if (el && text) el.textContent = text; };
      set('[data-cgb-popup-heading]', popup.heading);
      set('[data-cgb-popup-text]', popup.text);
      set('[data-cgb-quiz-results]', popup.resultsLabel);
      set('[data-cgb-quiz-retake]', popup.retakeLabel);
      var url = window.CgbQuiz.quizUrl();
      var results = this.querySelector('[data-cgb-quiz-results]');
      var retake = this.querySelector('[data-cgb-quiz-retake]');
      if (results) results.setAttribute('href', url);
      if (retake) retake.setAttribute('href', url + '#retake');
    }

    open(trigger) {
      if (!this.modal) return;
      this.applyConfig();
      this.lastTrigger = trigger || document.activeElement;
      this.modal.hidden = false;
      requestAnimationFrame(() => this.modal.classList.add('is-open'));
      document.documentElement.classList.add('cgb-quiz-open');
      document.addEventListener('keydown', this.onKeydown);
      if (typeof window.trapFocus === 'function') window.trapFocus(this.panel);
      else if (this.panel) this.panel.focus();
    }

    close(restoreFocus = true) {
      if (!this.modal || this.modal.hidden) return;
      this.modal.classList.remove('is-open');
      this.modal.hidden = true;
      document.documentElement.classList.remove('cgb-quiz-open');
      document.removeEventListener('keydown', this.onKeydown);
      if (typeof window.removeTrapFocus === 'function') window.removeTrapFocus(restoreFocus ? this.lastTrigger : null);
      else if (restoreFocus && this.lastTrigger && this.lastTrigger.focus) this.lastTrigger.focus();
    }
  }
  customElements.define('cgb-quiz-popup', CgbQuizPopup);
}
